import _styled from "styled-components";
import React from "react";
import { Header } from "../Header/Header";

var Container = _styled.div.withConfig({
  displayName: "TextPage__Container",
  componentId: "p1wmof-0"
})(["flex:1;display:flex;flex-direction:column;height:100%;"]);

var Content = _styled.div.withConfig({
  displayName: "TextPage__Content",
  componentId: "p1wmof-1"
})(["flex:1;padding:20px;display:flex;align-items:center;justify-content:center;text-align:center;font-size:36px;"]);

export function TextPage(_ref) {
  var children = _ref.children,
      backTo = _ref.backTo;
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Header, {
    backTo: backTo
  }), /*#__PURE__*/React.createElement(Content, {
    children: children
  }));
}